<template>
    <div class="menu">
        <div class="header">
            <div class="break-box" >
                <div class="break">
                    <i class="el-icon-back" ></i>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">HOME</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/browse' }">Browse</el-breadcrumb-item>
                        <el-breadcrumb-item>
                            <span style="cursor:default;font-weight: 600;color:#09CA6A;font-size: 16px;">{{ slug }}-menu</span>
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
            <div class="mer-box">
                <div class="info-box" >
                    <div class="l-box">
                        <span class="img-block" >
                            <img v-if="merInfo.merchantLogo" :src="merInfo.merchantLogo" alt="">
                        </span>
                        <span class="status-tag" v-if="!merInfo.merchantCloseStore" >Open</span>
                        <span class="status-tag status-tag-close" v-else >Closed</span>
                    </div>
                    <div class="r-box">
                        <h2 class="title" :style="{'font-size': titleSize}">{{ merInfo.restaurantName }}
                        </h2>
                        <div class="info-item" v-if="merInfo.merchantAddr">
                            <i class="el-icon-location"></i>
                            <span>{{ merInfo.merchantAddr }}</span>
                        </div>
                        <div class="info-item" v-if="merInfo.tasteRating">
                            <el-rate style="position: relative;top:2px;" v-model="merInfo.tasteRating" :disabled="true" :colors="['#FFB800','#FFB800','#FFB800','#FFB800','#FFB800']"
                                    disabled-void-color="#CFC9C3"></el-rate>
                            <span>{{ merInfo.tasteRating }} (16) reviews</span>
                        </div>
                    </div>
                </div>
                <div class="focus-btn-box">
                    <div class="btn" @click="focusMerchant">
                        <i :class="['iconfont', {'icon-aixin': merInfo.isFavorite}, {'icon-aixin1': !merInfo.isFavorite}]"></i>
                        <span>Wishlist</span>
                    </div>
                    <div class="btn">
                        <i class="el-icon-picture-outline"></i>
                        <span>View Photos</span>
                    </div>
                </div>
            </div>
            <img src="@/assets/images/menu-cuise.png" class="menu-tag-img" alt="menu-cuise">
        </div>

        <!-- 菜单分类 -->
        <div class="category-box">
            <CategoryBox :categoryList="categoryList"  v-model="nowCateId"></CategoryBox>
        </div>
        <!-- 菜单部分 -->
        <div class="menu-box">
            <MenuBox :foodList="foodList" @addCart="addCart" :info="merInfo" :categoryList="categoryList" :currencySign="merInfo.currencySign" ></MenuBox>
        </div>

        <!-- 购物车部分 -->
        <div class="cart-box">
            <CartBox :cartList="cartList"></CartBox>
        </div>
        <div class="clear"></div>
        <br />

        <!-- 回到顶部按钮 -->
        <el-backtop :bottom='48' :right='140'>
            <i class="el-icon-caret-top"></i>
        </el-backtop>

    </div>
</template>

<script>
import { postGateway } from '@/request';
import MenuBox from '@/components/MenuComps/MenuBox.vue';
import CartBox from '@/components/MenuComps/CartBox.vue';
import CategoryBox from '@/components/MenuComps/CategoryBox.vue';
import bus from '@/utils/bus';
export default {
    components: {
        MenuBox,
        CartBox,
        CategoryBox
    },
    data() {
        return {
            merchantId: null,
            transType: 'delivery',
            pageLoading: true,
            slug: '',
            merInfo: {
                restaurantName: '',
                merchantId: '',
                merchantLogo: '',
                tasteRating: '',
                merchantAddr: '',
                deliveryDistance: ''
            },
            categoryList: [],
            foodList: [],
            nowCateId: '',
            keyword: '',
            cartList: []
        }
    },
    computed: {
        titleSize() {
            let size = (22 / this.merInfo.restaurantName.length  * 66);
            return size>66?66:size + 'px';
        }
    },
    created() {
        let slug = this.$route.params.pathMatch;
        this.slug = slug;
        this.pageLoading = true;
        this.getMerchantId(slug).then(()=>{
            this.getMerchantInfo();
            this.getCategoryList();  // 获取菜单分类
        })
        .catch(()=>{
            this.pageLoading = false;
        })
    },
    mounted() {
        
    },
    methods: {
        // 加入购物车
        addCart(food) {
            this.cartList.push(food)
            bus.$emit('addCard', food)
        },
        getMenuList(){
            postGateway({
                url: '/customerWeb/merchantDetail/getMerchantFood',
                method: 'GET',
                data: {
                    merchantId: this.merchantId,
                    catId: this.nowCateId,
                    keyword: this.keyword
                }
            }).then((res) => {
                if(res.code == 200){
                    this.foodList = res.data
                }
            })
        },
        getCategoryList() {
            postGateway({
                url: '/customerWeb/merchantDetail/getMerchantCat',
                method: 'GET',
                data: {
                    merchantId: this.merchantId
                }
            }).then(res=>{
                this.categoryList = res.data
                this.nowCateId = this.categoryList[0].catId
                this.getMenuList();
            })
        },
        focusMerchant() {
            this.merInfo.isFavorite = this.merInfo.isFavorite?0:1

        },
        getMerchantId(slug) {
            console.log(slug,'请求参数的 slug')
            return postGateway({
                url: "/customerWeb/merchantDetail/getMerchantBySlug",
                method: "GET",
                data: {
                    slug
                }
            }).then(res=>{
                this.merchantId = res.data*1
            })
        },
        getMerchantInfo() {
            let param = {
                merchantId: this.merchantId,
                type: this.transType == 'delivery'?1:this.transType == 'pickup'?2:this.transType == 'dinein'?3: 0,
            }
            postGateway({
                url: '/customerApp/merchantDetail/getMerchantDetail',
                method: 'GET',
                data: param
            })
            .then(res=>{
                this.merInfo = res.data
            })
            .catch(()=>{
                this.pageLoading = false;
            })
        },

    }
}
</script>

<style lang="scss" scoped>
.menu {
    width: 100%;
    min-height: 100vh;
    .header {
        width: 100%;
        height: 520px;
        background-image: url('../assets/images/notfoundBg.png');
        background-size: cover;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        position: relative;
        background-position: center;
        .break-box {
            flex: 1;
            box-sizing: border-box;
            padding: 48px 4%;

            .break {
                height: 380px;
                height: 44px;
                display: inline-flex;
                align-items: center;
                padding: 20px;
                border-radius: 22px;
                background-color: #0A191E;
                color: #FFFFFF;
                .el-icon-back {
                    color: #2680ED;
                    font-size: 22px;
                    margin-right: 10px;
                }
                :deep(.el-breadcrumb__inner) {
                    color: #fff;
                }
                :deep(.el-breadcrumb__separator) {
                    color: #fff;
                }
            }
        }
        .mer-box {
            height: 170px;
            padding: 0 5%;
            display: flex;
            flex-direction: row;
            position: relative;
            z-index: 20;
            .info-box {
                flex: 1;
                display: flex;
                flex-direction: row;
                .l-box, .r-box {
                    display: flex;
                    flex-direction: column;

                    .img-block {
                        display: flex;
                        height: 100px;
                        width: 100px;
                        border-radius: 8px;
                        overflow: hidden;
                        margin-bottom: 14px;
                        background-color: #e9e9e9;
                        background-size: 100% 100%;
                        background-position: left;
                        img {
                            height: 100px;
                            width: 100px;
                        }
                    }
                    .status-tag {
                        padding: 5px 20px;
                        font-weight: 700;
                        background-color: #428600;
                        color: #fff;
                        font-size: 16px;
                        border-radius: 4px;
                    }
                    
                    .status-tag-close {
                        background: #E9E9E9;
                        color: #939393;
                    }
                    .title {
                        position: relative;
                        top: -2px;
                        font-size: 60px;
                        color: #fff;
                        font-weight: 700;
                        margin: 0;
                        height: 66px;
                        margin-bottom: 10px;
                        white-space: nowrap;
                    }
                    .info-item {
                        color: #fff;
                        font-weight: 400;
                        display: flex;
                        align-items: center;
                        font-size: 17px;
                        margin-bottom: 6px;
                        :deep(.el-rate__icon) {
                            position: relative;
                            margin-top: -2px;
                            margin-right: -2px;
                            font-size: 20px;
                        }
                        span {
                            margin-left: 6px;
                        }
                        i {
                            color: #C2F93A;
                            font-size: 17px;
                        }
                    }
                }
                .l-box {
                    width: 100px;
                    align-items: center;
                    margin-right: 10px;
                }
            }
            .focus-btn-box {
                display: flex;
                align-items: flex-end;
                margin-bottom: 10px;

                .btn {
                    margin-left: 10px;
                    max-height: 40px;
                    padding: 12px 17px;
                    border-radius: 4px;
                    color: #0A191E;
                    font-size: 15px;
                    display: inline-flex;
                    align-items: center;
                    border-radius: 6px;
                    background-color: #fff;
                    box-shadow: 0px 5px 10px #8F9698;
                    white-space: nowrap;
                    cursor: pointer;
                    font-weight: 600;
                    transition: all ease-in-out .2s;
                    &:hover {
                        background-color: #dedcdc;
                    }
                    i {
                        font-size: 20px;
                        margin-right: 5px;
                    }
                }
            }
        }
        .menu-tag-img {
            width: 430px;
            position: absolute;
            bottom: 0;
            right: 15%;
        }
    }

    .category-box {
        float: left;
        box-sizing: border-box;
        display: inline-flex;
        flex-direction: column;
        min-width: 300px;
        width: 22%;
        min-height: 400px;
        top: -10px;
        position: -webkit-sticky;
        position: sticky;
        z-index: 20;
        margin-left: 5%;
        padding-top: 20px;
    }
    .menu-box {
        display: inline-flex;
        flex-direction: column;
        width: calc(100vw - 54%);
        overflow: hidden;
        min-width: 400px;
    }
    .cart-box {
        float: right;
        display: inline-flex;
        flex-direction: column;
        min-width: 300px;
        width: 22%;
        min-height: 400px;
        position: -webkit-sticky;
        position: sticky;
        z-index: 20;
        top: -10px;
        padding-top: 20px;
        right: 5%;
    }
    .clear {
        clear: both;
    }

    :deep(.el-backtop) {
        z-index: 199;
    }
}
</style>